import { schema } from "normalizr";

export const payrollPeriod = new schema.Entity('payrollPeriod', {}, { idAttribute: 'type' });
export const payrollCategory = new schema.Entity('payrollCategory', {});
export const jobTitle = new schema.Entity('jobTitle', {});

export const organizationChartItem = new schema.Entity('organizationChart', {
  payroll_categories: [payrollCategory],
  jobTitles: [jobTitle],
  payroll_period: payrollPeriod
});

organizationChartItem.define({ children: [organizationChartItem] });

export const organizationChart = new schema.Array(organizationChartItem);
